import { io } from 'socket.io-client';
import { getAccessToken } from './axios.js';

/**
 * Realtime туташуу (ТЗ 10.4) — фондогу иштин прогресси үчүн.
 *
 * Бүт колдонмого БИР туташуу. Дарек берилбейт: браузер өз доменине кайрылат,
 * `/socket.io` ошол эле прокси аркылуу серверге барат — CORS жок.
 *
 * Токен функция менен берилет: кайра туташканда (ноутбук уктап ойгонгондо,
 * интернет үзүлгөндө) жаңыртылган токен окулат, эскиси менен кагылбайт.
 */
let socket = null;

export function getSocket() {
  if (!socket) {
    socket = io({
      autoConnect: false,
      auth: (cb) => cb({ token: getAccessToken() }),
      reconnectionDelayMax: 10_000,
    });
  }
  if (!socket.connected && getAccessToken()) socket.connect();
  return socket;
}

/** Чыгууда — сервер эски токен менен туташып калбасын */
export function closeSocket() {
  socket?.disconnect();
  socket = null;
}

/**
 * Бөлмөгө кирүү. Сервер окуяларды долбоордун жана главанын бөлмөсүнө жиберет
 * (`socket/index.js`), ошондуктан кардар кайсы бетте турса, ошол бөлмөдө болот.
 * @returns {() => void} бөлмөдөн чыгуу
 */
export function joinRoom(kind, id) {
  if (!id) return () => {};
  const s = getSocket();
  const enter = () => s.emit(`subscribe:${kind}`, id);

  // Туташа элек болсо emit буферге түшөт, анан 'connect'те дагы жиберилип,
  // эки эселенет — ошондуктан туташып турганда гана дароо жиберебиз.
  if (s.connected) enter();
  // Үзүлүп кайра туташканда бөлмө жоголот — кайрадан киребиз
  s.on('connect', enter);

  return () => {
    s.off('connect', enter);
    // Үзүлүп турса жибербейбиз: буферде калып, кайра туташканда эски
    // бөлмөдөн чыгуу болуп кетмек
    if (s.connected) s.emit(`unsubscribe:${kind}`, id);
  };
}

/** Окуяга жазылуу; кайтарган функция жазылуудан чыгарат */
export function onSocket(event, handler) {
  const s = getSocket();
  s.on(event, handler);
  return () => s.off(event, handler);
}

export const SOCKET_EVENT = Object.freeze({
  JOB_PROGRESS: 'job:progress',
  JOB_DONE: 'job:done',
  JOB_FAILED: 'job:failed',
});
